import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleCardComponent } from './toggle-card.component';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

@NgModule({
  declarations: [
    ToggleCardComponent
  ],
  imports: [CommonModule, MatSlideToggleModule],
  exports: [
    ToggleCardComponent
  ],
})
export class ToggleCardModule { }
